import React from 'react'
import {
  MdCheckCircle,
  MdClose,
  MdErrorOutline,
  MdOutlineMarkEmailRead,
} from 'react-icons/md'

const Alert = ({
  status,
  title,
  message,
  badge,
  autoCloseLabel,
  onClose,
}) => {
  const isSuccess = status === 'success'
  const Icon = isSuccess ? MdCheckCircle : MdErrorOutline
  const accentClasses = isSuccess
    ? 'from-emerald-500 via-teal-500 to-cyan-500'
    : 'from-rose-500 via-orange-500 to-amber-500'
  const iconClasses = isSuccess
    ? 'bg-emerald-100 text-emerald-600'
    : 'bg-rose-100 text-rose-600'
  const chipClasses = isSuccess
    ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
    : 'border-rose-200 bg-rose-50 text-rose-700'
  const chips = isSuccess
    ? ['Message delivered', 'Team notified', 'Reply within 24 hours']
    : ['Please try again', 'Check your connection', 'Use email if urgent']

  return (
    <div className='relative w-full max-w-md overflow-hidden rounded-[28px] bg-white shadow-[0_30px_80px_rgba(15,23,42,0.25)]'>
      <div className={`h-2 w-full bg-gradient-to-r ${accentClasses}`} />

      <div className='absolute -right-12 -top-12 h-36 w-36 rounded-full bg-tealGreen/10 blur-2xl' />
      <div className='absolute -left-10 bottom-10 h-28 w-28 rounded-full bg-primaryGreen/10 blur-2xl' />

      <button
        type='button'
        onClick={onClose}
        className='absolute right-4 top-4 z-10 flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white/90 text-slate-500 transition hover:border-slate-300 hover:text-slate-700'
        aria-label='Close popup'
      >
        <MdClose size={20} />
      </button>

      <div className='relative flex flex-col gap-6 p-7'>
        <div className='flex items-start gap-4'>
          <div
            className={`flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl ${iconClasses}`}
          >
            <Icon size={34} />
          </div>

          <div className='space-y-2 pr-10'>
            <div className='inline-flex items-center rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.24em] text-slate-500'>
              {badge}
            </div>
            <div className='text-2xl font-bold leading-tight text-slate-900'>
              {title}
            </div>
            <p className='text-sm leading-6 text-slate-600'>{message}</p>
          </div>
        </div>

        <div className='rounded-3xl border border-slate-200 bg-slate-50/80 p-4'>
          <div className='mb-3 flex items-center gap-2 text-sm font-semibold text-slate-700'>
            <MdOutlineMarkEmailRead
              size={18}
              className='text-tealGreen'
            />
            {isSuccess ? 'What happens next' : 'Quick recovery tips'}
          </div>
          <div className='flex flex-wrap gap-2'>
            {chips.map((chip) => (
              <span
                key={chip}
                className={`rounded-full border px-3 py-2 text-xs font-semibold ${chipClasses}`}
              >
                {chip}
              </span>
            ))}
          </div>
        </div>

        <div className='flex items-center justify-between gap-3'>
          <div className='text-sm text-slate-500'>{autoCloseLabel}</div>
          <button
            type='button'
            onClick={onClose}
            className={`rounded-full px-5 py-3 text-sm font-semibold text-white transition ${
              isSuccess
                ? 'bg-tealGreen hover:bg-tealGreen/90'
                : 'bg-slate-800 hover:bg-slate-700'
            }`}
          >
            {isSuccess ? 'Perfect' : 'Close'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default Alert
